import { Col, ColProps, Divider, Form, Row, Skeleton } from 'antd';
import { CSSProperties, FC, Fragment, ReactNode } from 'react';

export type DataRow = [ReactNode, ReactNode];
export type DataRowItem = [DataRow, DataRow?];

export type DataRowProps = {
	items: (DataRowItem | undefined)[];
	loading?: boolean;
	style?: CSSProperties;
	col?: number;
	labelCol?: ColProps;
	wrapperCol?: ColProps;
};

const DataRow: FC<DataRowProps> = ({
	items,
	loading,
	style,
	col = 12,
	labelCol = { span: 10 },
	wrapperCol = { span: 14 },
}) => {
	return (
		<Form
			style={style}
			colon={false}
			labelAlign="left"
			labelCol={{
				span: 10,
			}}
			className="form-data-row"
		>
			{items
				?.filter((item) => item)
				?.map((rows, index) => (
					<Fragment key={index}>
						<Row gutter={[40, 0]}>
							{rows
								?.filter((row) => row)
								?.map((row, rowIndex) => {
									const [label, value] = row ?? [];
									return (
										<Col
											span={col}
											key={rowIndex}
										>
											<Form.Item
												label={label ?? '-'}
												labelCol={labelCol}
												wrapperCol={wrapperCol}
											>
												{loading ? (
													<Skeleton
														active
														title={{
															width: '100%',
															style: {
																marginTop: 15,
															},
														}}
														avatar={false}
														style={{
															width: '100%',
														}}
														paragraph={false}
													/>
												) : (
													<div style={{ fontSize: 16 }}>{value || '-'}</div>
												)}
											</Form.Item>
										</Col>
									);
								})}
						</Row>
						{items.length !== index + 1 && <Divider />}
					</Fragment>
				))}
		</Form>
	);
};

export default DataRow;
